import { StarterArticles, StarterArticleSource } from '../../../../types/StarterGuideTypes';

export const articles: StarterArticles = {
  title: 'Learn More',
  articles: [
    {
      title: 'What to Feed a Puppy and When to Switch to Adult Dog Food',
      image:
        '/sites/default/files/styles/additional_slideshows_281_192/public/pug-puppies-around-water-bowl.jpg',
      link: '/blogs/nutritionnuggets/jcoates/2012/may/special_nutritio nal_needs_of_puppies-23692',
      source: StarterArticleSource.PET_MD,
    },
    {
      title: 'What Is the Best Dog Food?',
      image:
        '/sites/default/files/styles/additional_slideshows_281_192/public/2021-01/dog-yorkshire-terrier-with-a-bowl-of-food-eating-food-picture-id1138155356.jpg',
      link: '/dog/nutrition/what-best-dog-food',
      source: StarterArticleSource.PET_MD,
    },
    {
      title: 'Dry Dog Food vs. Wet Dog Food: Which Is Better?',
      image:
        '/sites/default/files/styles/additional_slideshows_281_192/public/2021-01/two-dogs-eating-together-from-their-food-bowls.jpg',
      link: '/dog/nutrition/dry-dog-food-vs-wet-dog-food-which-better',
      source: StarterArticleSource.PET_MD,
    },
  ],
};
